import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { trackBusinessError } from '@sxm-de/dev-kits/web-sdk/utils';

interface RedeemMagicLinkSalFnPayload {
    magicLinkId: string;
}

export type RedeemMagicLinkSalFn = (
    payload: RedeemMagicLinkSalFnPayload,
) => Promise<{
    grant: string;
}>;

export function initRedeemMagicLinkSalFn({
    dependencies: { clientSdk, appEventSdk },
}: DomainInitPayload): RedeemMagicLinkSalFn {
    return async ({ magicLinkId }: RedeemMagicLinkSalFnPayload) => {
        try {
            return await clientSdk.user.magicLinkRedeem(magicLinkId);
        } catch (error: any) {
            switch (error.code) {
                case 'userServices.magicLink.magicLinkNotFound':
                    trackBusinessError(appEventSdk, error);
                    throw new Error('MAGIC_LINK_NOT_FOUND');
                case 'userServices.magicLink.magicLinkExpired':
                    trackBusinessError(appEventSdk, error);
                    throw new Error('MAGIC_LINK_EXPIRED');
                case 'userServices.magicLink.invalidBaseUrl':
                    trackBusinessError(appEventSdk, error);
                    throw new Error('INVALID_BASE_URL');
                default:
                    /**
                     * TODO:
                     * Log error to error logger (not analytics).
                     */
                    throw new Error('SYSTEM');
            }
        }
    };
}
